import React, { useState, useEffect, Fragment } from 'react';
import { useStore } from '@nanostores/react';
import { isCartOpen, cartData } from '@stores/cartStore.js';
import va from '@vercel/analytics';
import 'balloon-css';
import { createCart, addToCart } from '@api/shopify.js';
import { slugify, getUniqueListBy } from '@utils/utils.js';
import { handleRemoveItem } from '@components/Cart/cartUtility.jsx';
import { fileNameAndExt } from '../../utils/utils';

const FREE_PRODUCT_QUERY_URL =
	'https://services.mybcapps.com/bc-sf-filter/search?shop=monicaandandyonline.myshopify.com&limit=70&q=free-organic-lounge-robe';

const FILES_URL = 'https://cdn.shopify.com/s/files/1/2338/2917/files/';

const productData = await fetch(FREE_PRODUCT_QUERY_URL).then((r) => r.json());

//

// const freeProductIds = [
//     '7256370741310', '40227788685374', '40227788718142', '40227788750910', '40227788783678' , '7256368709694','40227787210814', '40227787243582', '40227787276350', '40227787309118'
// ]

const freeProductIds = [
	7265596604478, 7322173341758, 7265594540094, 7265596997694, 40242161516606,
	40242161549374, 40242161582142, 40242146738238, 40242162630718,
	40242162663486, 40242162696254, 40447216025662, 40447216058430,
	40447216091198, 40447216123966,
];

const FreeProduct = () => {
	const $cartData = useStore(cartData) || null;
	const [thresholdMet, setThresholdMet] = useState(false);
	const [currentSize, setCurrentSize] = useState({});
	const [freeProductAdded, setFreeProductAdded] = useState(false);
	const [showDetails, setShowDetails] = useState(false);
	const [threshold, setThreshold] = useState(null);
	const [data, setData] = useState({});

	let freeProduct;

	useEffect(() => {
		if (data && data.freeProduct) {
			setThreshold(parseFloat(data.freeProduct).toFixed(2));
		}
	}, [data]);

	useEffect(() => {
		let cartLines;

		if ($cartData) {
			cartLines = $cartData.lines;

			let freeRobeInCart = cartLines?.filter((line) => {
				//
				const lineId = Number(
					line.node.merchandise.id.split('/').pop()
				);
				return freeProductIds.includes(lineId);
			});

			//

			if (freeRobeInCart && freeRobeInCart.length > 0) {
				setFreeProductAdded(true);
			}
		}
	}, []);

	useEffect(() => {
		//
		if (threshold && threshold <= 0) {
			setThresholdMet(true);
		} else {
			setThresholdMet(false);
			//

			let cartLines;
			let itemToBeRemoved;

			if ($cartData) {
				cartLines = $cartData.lines;

				itemToBeRemoved = cartLines?.filter((line) => {
					const item = line.node;
					let id = item?.merchandise?.id.split('/').pop();
					id = Number(id);
					//
					return freeProductIds.includes(id);
				});

				//

				if (itemToBeRemoved && itemToBeRemoved.length) {
					const cartId = $cartData.cartId;
					const itemToBeRemovedId = itemToBeRemoved[0]?.node.id;

					//

					handleRemoveItem(cartId, itemToBeRemovedId);
					setFreeProductAdded(false);

					let $newCartData = cartData.get();

					//

					setData({
						...$newCartData,
						freeProduct:
							parseFloat(125 - $newCartData.subTotal).toFixed(
								2
							) || 0,
					});
				}
			}
		}
	}, [threshold]);

	useEffect(() => {
		if ($cartData) {
			let $newCartData = cartData.get();
			//

			const invalidProductTypes = [
				'Gift Cards',
				'Gift Card',
				'Specialty SKU',
				'Embroidery Option',
				'Embroidery',
				'Virtual Classes',
				'Classes + Events',
				'Nursery',
				'Cribs',
				'Classes',
				'Strollers',
			];

			const lines = $newCartData?.lines || null;

			let applicableLines;

			// get applicable items subtotal
			if (lines && lines.length > 0) {
				applicableLines = lines.filter((line) => {
					const item = line.node;
					const productType = item?.merchandise?.product?.productType;
					const vendor = item?.merchandise?.product?.vendor;
					return (
						!invalidProductTypes.includes(productType) &&
						vendor === 'Monica + Andy'
					);
				});
			}

			//

			let subTotal;
			let subtotal;

			if (applicableLines && applicableLines.length > 0) {
				subtotal = applicableLines.reduce(function (
					previousValue,
					currentValue
				) {
					//
					return (
						parseFloat(previousValue) +
						parseFloat(currentValue.node.cost.totalAmount.amount)
					);
				},
				0);
			} else {
				subtotal = 0;
				freeProduct = 125;
			}

			if (subtotal) {
				subTotal = parseFloat(subtotal).toFixed(2) || 0;
				freeProduct = parseFloat(125 - subTotal).toFixed(2) || 0;
			}

			//

			setData({
				...$newCartData,
				subTotal: subTotal,
				freeProduct: freeProduct ? freeProduct : 0,
			});
		}
	}, [$cartData]);

	let variants = [];
	let product;
	let products;
	let productsWithVariants;
	let productSizes = [];
	let productSwatches = [];
	let allProductImages = [];

	if (
		productData &&
		productData.products &&
		productData.products.length > 0
	) {
		products = productData?.products;

		//

		products = products.filter((p) => {
			return p.title.indexOf('Free') > -1;
		});

		productsWithVariants = products.filter((p) => {
			return p.title.indexOf('hidden') === -1;
		});

		//

		if (productsWithVariants.length > 0) {
			productsWithVariants.map((p) => {
				variants.push(p.variants);
				return null;
			});

			allProductImages = productsWithVariants.map((p) => {
				return p.images_info[0];
			});
		}

		variants = variants.flat(1);

		variants = variants.reverse();

		//

		//
		productSizes = variants.map((v) => {
			if (
				v.inventory_quantity > 0 &&
				v.initial_color === variants[0].initial_color
			) {
				return {
					variantId: v.id,
					title: v.title,
					price: v.price,
					size: v.initial_size || '',
					initial_size: v.initial_size || '',
					sku: v.sku,
					inventory_quantity: v.inventory_quantity,
				};
			}
		});

		productSizes = productSizes.filter(Boolean);

		//

		// productSizes = getUniqueListBy(productSizes, 'initial_size')

		variants.map((v) => {
			if (v.inventory_quantity > 0 && v.initial_color) {
				productSwatches.push(v.initial_color);
			}
			return null;
		});
	}

	productSwatches = [...new Set(productSwatches)];

	//

	//

	const imageSrcArray = fileNameAndExt(variants[0]?.image);

	//

	const smallImageSrc =
		imageSrcArray[0] +
		'/' +
		imageSrcArray[1] +
		'_300x450.' +
		imageSrcArray[2];

	const [currentColor, setCurrentColor] = useState(
		variants[0]?.initial_color
	);
	const [currentImage, setCurrentImage] = useState({
		src: smallImageSrc,
		alt: variants[0]?.title,
	});
	const [currentVariantId, setCurrentVariantId] = useState(variants[0]?.id);
	const [currentSizes, setCurrentSizes] = useState(productSizes || []);

	const handleSizeClick = (size, variantId, index, sku) => {
		let ele = document.getElementsByClassName('size size-selected');
		if (ele.length > 0) {
			ele[0].classList.remove('size-selected');
		}

		//
		setCurrentSize({
			size: size,
			variantId: variantId,
			sku: sku,
		});

		setCurrentVariantId(variantId);
	};

	const handleSwatchClick = (swatchSlug, swatchTitle, index) => {
		let ele = document.getElementsByClassName('size size-selected');
		if (ele.length > 0) {
			ele[0].classList.remove('size-selected');
		}
		//

		swatchTitle = swatchTitle.replace(/\//g, ' ');

		//

		let newImage = allProductImages.filter((n, i) => {
			return n.alt === swatchSlug;
		});

		//

		productSizes = [];

		//
		productSizes = variants.map((v) => {
			if (v.inventory_quantity > 0 && v.initial_color === swatchTitle) {
				return {
					variantId: v.id,
					title: v.title,
					price: v.price,
					size: v.initial_size || '',
					initial_size: v.initial_size || '',
					sku: v.sku,
					inventory_quantity: v.inventory_quantity,
				};
			}
		});

		productSizes = productSizes.filter(Boolean);

		setCurrentSizes(productSizes);

		//

		setCurrentImage(newImage[0]);

		setCurrentColor(swatchTitle);

		setCurrentSize({});
	};

	const handleAddToCart = async (e) => {
		//

		const noClick = e.target.classList.contains('noclick');

		if (noClick) {
			return;
		}
		e.preventDefault();

		let cartId = $cartData.cartId || '';

		let variantId = currentSize.variantId;

		const product = `gid://shopify/ProductVariant/${variantId}`;

		let lines = {
			quantity: 1,
			merchandiseId: product,
		};

		let quantity = 1;

		if (!cartId || cartId === '') {
			let cartCreateData = await createCart();
			cartId = cartCreateData.data.cartId;

			let cartObj = {
				...cartData.get(),
				cartId: cartId,
				checkoutUrl: cartCreateData.data.checkoutUrl,
			};

			cartData.set(cartObj);

			addToCart(cartId, lines).then((addToCartData) => {
				let cartLines =
					addToCartData.body.cartLinesAdd.cart.lines.edges;
				let cartCost = addToCartData.body.cartLinesAdd.cart.cost;

				let cartObj = {
					...cartData.get(),
					lines: cartLines,
					cost: cartCost,
				};

				cartData.set(cartObj);

				isCartOpen.set('is_cart_open', true);

				dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
				dataLayer.push({
					event: 'add_to_cart',
					page: 'cart free',
					ecommerce: {
						currency: 'USD',
						value: currentSize.price,
						items: [
							{
								item_id: variantId,
								item_name: product.title,
								affiliation: 'Vercel',
								item_brand: 'Monica + Andy',
								// item_category: currentPattern ? currentPattern : '',
								item_category2: currentSize?.size,
								item_variant: currentSize?.variantId,
								price: currentSize.price,
								quantity: quantity,
							},
						],
					},
				});

				va.track('Free Product Added To Cart', {
					productName: product.title,
					productSku: currentSize?.sku,
					productBrand: product?.vendor
						? product.vendor
						: 'Monica + Andy',
					// productColor: currentPattern ? currentPattern : '',
					productSize: currentSize?.size,
					productVariant: currentSize?.variantId,
					productPrice: currentSize?.price,
					productQuantity: quantity,
				});

				setFreeProductAdded(true);
			});
		} else {
			addToCart(cartId, lines).then((addToCartData) => {
				let cartLines =
					addToCartData.body.cartLinesAdd.cart.lines.edges;
				let cartCost = addToCartData.body.cartLinesAdd.cart.cost;

				let cartObj = {
					...cartData.get(),
					lines: cartLines,
					cost: cartCost,
				};

				cartData.set(cartObj);

				isCartOpen.set('is_cart_open', true);

				dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
				dataLayer.push({
					event: 'add_to_cart',
					page: 'cart free',
					ecommerce: {
						currency: 'USD',
						value: currentSize?.price,
						items: [
							{
								item_id: variantId,
								item_name: product.title,
								affiliation: 'Vercel',
								item_brand: 'Monica + Andy',
								// item_category: currentPattern
								//     ? currentPattern
								//     : '',
								item_category2: currentSize?.size,
								item_variant: currentSize?.variantId,
								price: currentSize?.price,
								quantity: quantity,
							},
						],
					},
				});

				va.track('Free Product Added To Cart');

				setFreeProductAdded(true);
			});
		}
	};

	//

	return (
		<Fragment>
			{thresholdMet && !freeProductAdded ? (
				<div className='free-product-outer mb-6 bg-oat/20 py-4'>
					<div className='free-product-inner flex flex-col px-4 text-center justify-center'>
						<div className='free-product-header mb-3'>
							<div className='free-product-title text-sm font-medium'>
								<h3 className='text-lg lg:text-xl mb-2'>
									You've qualified for a FREE
									<br />
									Organic Lounge Robe!
								</h3>
							</div>
							<p className='text-xs font-normal'>
								Please select your options and add the item to
								your cart.
							</p>
						</div>
						{variants ? (
							<div className='product-outer pt-4 border-t border-oat'>
								<div className='product-inner'>
									<div className='product-wrap flex gap-3 mb-4 text-left justify-center'>
										<div className='product-image w-1/2'>
											<img
												src={currentImage?.src}
												alt={currentImage?.alt}
											/>
										</div>
										<div className='product-info w-1/2'>
											<div className='product-title text-sm font-medium mb-2'>
												{products[0].title.replace(
													'[hidden]',
													''
												)}
											</div>
											<div className='product-price text-sm font-normal'>
												<span className='line-through text-red-500 font-semibold'>
													$65.00
												</span>{' '}
												<span className='font-semibold'>
													FREE!
												</span>
											</div>
											<div className='product-actions flex flex-col'>
												<div className='product-swatches my-2'>
													<ul className='swatch-list pattern-list nostyle flex flex-wrap gap-x-1'>
														{productSwatches.map(
															(s, i) => {
																//
																const swatchSlug =
																	slugify(s);
																return (
																	<li
																		key={
																			swatchSlug
																		}
																		className={`swatch swatch-item w-10 hover:cursor-pointer ${
																			currentColor &&
																			currentColor ===
																				s.replace(
																					/\//g,
																					' '
																				)
																				? 'swatch-selected'
																				: ''
																		}`}
																		data-swatch-index={
																			i
																		}
																		data-swatch-color={
																			swatchSlug
																		}
																		aria-label={
																			s
																		}
																		data-balloon-pos='up'
																		onClick={() =>
																			handleSwatchClick(
																				swatchSlug,
																				s,
																				i
																			)
																		}
																	>
																		<div className='swatch-image'>
																			<img
																				className='rounded-full border border-oat hover:border-ocean hover:border-2'
																				src={`${FILES_URL}maswatch-${swatchSlug}-96.png`}
																				alt={
																					s.color
																				}
																				loading='lazy'
																			/>
																		</div>
																	</li>
																);
															}
														)}
													</ul>
												</div>
												<div className='product-sizes my-2'>
													{currentSizes &&
													currentSizes.length > 0 ? (
														<ul className='size-list nostyle flex gap-1 lg:gap-2'>
															{currentSizes
																.reverse()
																.map((s, i) => {
																	//
																	return (
																		<li
																			key={
																				s.initial_size
																			}
																			className={`size h-[24px] lg:h-[36px] border border-oat rounded-sm flex items-center justify-center px-2 text-sm hover:cursor-pointer hover:bg-flint hover:text-white w-[60px] ${
																				currentSize.size &&
																				currentSize.size ===
																					s.initial_size
																					? 'size-selected bg-ash text-white'
																					: 'bg-white'
																			} ${
																				s.inventory_quantity ===
																				0
																					? 'size-out-of-stock cursor-not-allowed pointer-events-none'
																					: ''
																			}`}
																			onClick={() =>
																				handleSizeClick(
																					s.initial_size,
																					s.variantId,
																					i,
																					s.sku
																				)
																			}
																			data-variant-id={
																				s.variantId
																			}
																		>
																			<span className='size-label text-xs'>
																				{
																					s.initial_size
																				}
																			</span>
																		</li>
																	);
																})}
														</ul>
													) : null}
												</div>

												<div className='product-add-to-cart w-full flex my-3'>
													{productSizes &&
													productSizes.length ? (
														<button
															type={
																!currentSize.size
																	? null
																	: 'submit'
															}
															className={`large-button button-atc h-42px w-full ${
																!currentSize.size
																	? 'disabled noclick cursor-not-allowed opacity-20'
																	: ''
															}`}
															data-variant-id={
																currentSize.variantId
															}
															// data-balloon-blunt
															data-balloon-pos='up'
															aria-label={
																!currentSize.size
																	? 'Please select a size'
																	: null
															}
															onClick={(e) =>
																handleAddToCart(
																	e
																)
															}
														>
															Add To Cart
														</button>
													) : null}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						) : null}
					</div>
				</div>
			) : (
				<Fragment>
					<div className='free-product-remainder-outer bg-sun '>
						<div className='free-product-remainder-inner p-4 flex flex-col items-center justify-center'>
							<div className='free-product-remainder flex items-center text-center justify-center'>
								{data &&
								data.subTotal > 0 &&
								data.subTotal < 125 &&
								data.freeProduct ? (
									<span className='text-sm'>
										Spend{' '}
										<span className='font-medium'>
											${data.freeProduct}
										</span>{' '}
										more to get a FREE Organic Lounge Robe -
										a $65 value!
									</span>
								) : data.subTotal >= 125 ? (
									<span className='text-sm'>
										You've qualified for a FREE Organic
										Lounge Robe - a $65 value!
									</span>
								) : (
									<span className='text-sm'>
										Spend $125 and get a FREE
										<br />
										Organic Lounge Robe — a $65 value!
									</span>
								)}
							</div>
							<div className='free-product-image mt-2 max-w-[150px]'>
								<img
									src='https://cdn.shopify.com/s/files/1/2338/2917/files/Red-hearts_OnModel_robe_pjs_021_300x450.webp?v=1706043062'
									alt='Free Organic Lounge Robe'
									loading='lazy'
								/>
							</div>
						</div>
					</div>

					<div className='free-shipping-details text-xs text-center font-normal'>
						<span
							className='cursor-pointer'
							onClick={() => setShowDetails(!showDetails)}
						>
							* {showDetails ? 'Hide ' : 'Show '}Details
						</span>
						{showDetails ? (
							<div className='text-[10px] text-center font-normal px-4'>
								Based on elligible products in cart. Gift Cards,
								embroidery, classes, digital products, and
								specialty SKUs do not count towards the $100
								threshold.
							</div>
						) : null}
					</div>
				</Fragment>
			)}
		</Fragment>
	);
};
export default FreeProduct;
